import { Reveal, MaskText, Eyebrow } from "@/components/motion";
import { RegistrationForm } from "@/components/form/RegistrationForm";

export const RegistrationSection = () => (
  <section id="iscrizione" className="section border-t border-line bg-ink2" data-testid="registration-section">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-[radial-gradient(50%_100%_at_30%_0%,rgba(199,154,75,0.14),transparent)]" />
    <div className="wrap relative grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
      <div className="lg:sticky lg:top-12 lg:self-start">
        <Eyebrow>Iscrizione</Eyebrow>
        <MaskText className="h2 mt-6" lines={["Riserva il tuo posto", <em className="gold-text">alle 2 serate</em>]} />
        <Reveal>
          <p className="lead mt-8">Meno di due minuti, dal telefono. Riservato alle titolari. €27 + IVA, con fattura intestata al tuo centro. Dopo il pagamento ricevi il link Zoom, il PDF Super Glow e i promemoria su WhatsApp.</p>
        </Reveal>
      </div>
      <Reveal><RegistrationForm /></Reveal>
    </div>
  </section>
);
